// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"e8fabb28","36":"91ada27e","263":"f33b15f7","341":"250af722","615":"d26306af","791":"67f50d6a"}[chunkId] + ".chunk.css";
};